import * as React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import WeddingAppBar from './AppBar.tsx'
import sunset from '../gallery/IMG_4450-full.png'

const styles = {
  // heroContainer: {
  //   height: {xs: "100vh"},
  //   maxHeight: "800",
  //   backgroundImage: `url(${"IMG_4450.png"})`,
  //   backgroundSize: {xs: 'auto 100vh', lg: "auto 100vw"},
  //   backgroundRepeat: "no-repeat",
  //   backgroundPosition: {xs: "top center", lg:"bottom center"},
  //   backgroundAttachment: "scroll",
  //   alignItems: "center",
  //   justifyContent: "center",
  //   boxShadow: "3"
  // }
  heroContainer: {
      //height: {xs: "100vw"},
      //width: "100vw",
      //maxHeight: {xs: "100vh", md: "400px"},
      // backgroundImage: `url(${"IMG_4450-full.png"})`,
      // backgroundSize: {xs: 'cover', lg: "cover"},
      // backgroundRepeat: "no-repeat",
      // backgroundPosition: {xs: "center", lg:"center right"},
      // backgroundAttachment: "scroll",
      alignItems: "center",
      justifyContent: "center",
      padding: {xs: 0},
      //verticalAlign: "bottom"
    }
 };

const textStyle = {
  flexGrow: 1,
  backgroundColor: "transparent", 
  alignSelf: "center", 
  textAlign: "center", 
  textWrap: "nowrap",
  //textColor: "red",
  //textShadow: "1px 1px #c9b7ab",
  fontFamily: '"Waterfall", serif',
  color: "#E97C3B",
}
const textStyle2 = {
  flexGrow: 1,
  backgroundColor: "transparent", 
  alignSelf: "center", 
  textAlign: "center", 
  textWrap: "nowrap",
  fontFamily: '"Tangerine", serif',
  color: "#E97C3B",
  fontSize: {xs: "3rem", sm: "5rem", md: "6rem", lg: "7rem"},
  mx: "auto",
  verticalAlign: 'bottom'
}

 export default function Hero() {
  return (
    <Container sx={ styles["heroContainer"] }>
      <WeddingAppBar />
      <Card sx={{ 
        minWidth: "300px",
        alignSelf: "center",
        align: "center",
        boxShadow: "3",
        backgroundColor: "#0a0a08",
        p:0,
      }}>
        <CardMedia
          sx={{ 
            maxHeight: {xs: "40vw", lg: 480},
            objectFit: "cover",
            objectPosition: "center",
            p:0,
          }}
          component="img"
          image={sunset}
          title="Take in the sunset!"
        />
        <CardContent sx={{px: 0}}>
          <Typography sx={textStyle2} component="div">Court and Andrew</Typography>
        </CardContent>
      </Card>
    </Container>
  );
}
